// Utils
import text from '@translations/en.json';
// Types
import { CapacitiesByUnit } from './separateCapacityUnit.types';

/**
 * Extracts and groups capacities by their units from an array of strings.
 * Each string in the array should have the format 'capacity/unit'.
 *
 * @param arr - An array of strings where each string represents a capacity
 * followed by its unit, separated by a '/'.
 *
 * @returns An object where each key represents a unit and its value is an
 * array of capacities associated with that unit. If there is at least one unit,
 * an 'All' key will be added to the returned object containing the capacities
 * of all units combined.
 */
export const getAllUnitsWithCapacities = (arr: string[]): CapacitiesByUnit => {
  const result: CapacitiesByUnit = {};

  arr.forEach((item) => {
    const [capacity, unit] = item.split('/');
    if (!result[unit]) {
      result[unit] = [];
    }
    result[unit].push(Number(capacity));
  });

  if (Object.keys(result).length >= 1) {
    result[text.all] = Object.values(result).reduce((acc, curr) => {
      return [...acc, ...curr];
    });
  }

  return result;
};
